const stripCellMask = (value) => value.replace(/\D/g, "").replace(/^(27)?0?/g, "");

const checkCell = (value) => {
    var clean_cell = stripCellMask(value);
    return clean_cell.length === 9 && parseInt(clean_cell.substring(0, 2), 10) >= 60;
};

export { checkCell };